/**
 * Mirrors the GraphQL `RuleActionType` enum's values, which both the survey and
 * the manager schema declare identically. Naming them here is what lets the
 * narrowing onto `ThreadAction` be written once and used by every adapter —
 * the same trick `SUPPORTED_DEVICES` and `QUESTION_SHAPES` play in
 * `@/shared-question-model`, for the same reason: the kernel may not import a
 * generated enum.
 */
export const RULE_ACTIONS = {
  CustomEndConversation: 'CUSTOM_END_CONVERSATION',
  CustomRedirect: 'CUSTOM_REDIRECT',
  FeedbackMessage: 'FEEDBACK_MESSAGE',
  PanelCompleteRedirect: 'PANEL_COMPLETE_REDIRECT',
  PanelOverQuotaRedirect: 'PANEL_OVER_QUOTA_REDIRECT',
  PanelQualityControlRedirect: 'PANEL_QUALITY_CONTROL_REDIRECT',
  PanelSecurityRedirect: 'PANEL_SECURITY_REDIRECT',
  PanelTerminateRedirect: 'PANEL_TERMINATE_REDIRECT',
  Question: 'QUESTION',
  Redirect: 'REDIRECT',
  ReviewRedirect: 'REVIEW_REDIRECT',
  SuccessMessage: 'SUCCESS_MESSAGE',
} as const;

export type RuleAction = (typeof RULE_ACTIONS)[keyof typeof RULE_ACTIONS];
